import { makeAutoObservable, runInAction, toJS } from 'mobx';


class MultipleTaskSearchStore {
  constructor() {
    makeAutoObservable(this);
  }

  currentFullScreenData = null;
  currentBuTaskId = null;

  setFullScreenData(data) {
    this.currentFullScreenData = data;
    this.currentBuTaskId = data?.buTaskId;
  }

};

export default new MultipleTaskSearchStore();